<template>
  <div class="z-msg">
    <el-dropdown
      trigger="click"
      class="z-msg-wrapper"
    >
      <!--  消息盒子外图标 -->
      <el-badge :value="newMsgNum">
        <span>
          <i class="z-msg__icon el-icon-bell"></i>
        </span>
      </el-badge>

      <!-- 消息盒子主体内容 -->
      <el-dropdown-menu
        slot="dropdown"
        class="z-msg__menu"
      >
        <el-tabs
          v-model="activeTab"
        >
          <el-tab-pane
            name="informs"
          >
            <span
              slot="label"
              class="z-msg__tab"
            >
              通知({{informsNum}})
            </span>

            <list
              :listData="msgTable.informs"
              @itemClick="itemClick"
            />
          </el-tab-pane>

          <el-tab-pane
            name="reminds"
          >
            <span
              slot="label"
              class="z-msg__tab"
            >
              消息({{remindsNum}})
            </span>

            <list :listData="msgTable.reminds" />
          </el-tab-pane>

          <el-tab-pane
            name="pendings"
          >
            <span
              slot="label"
              class="z-msg__tab"
            >
              待办({{pendingsNum}})
            </span>

            <list :listData="msgTable.pendings" />
          </el-tab-pane>
        </el-tabs>

      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
import Socket from './socket.js'
import list from './components/list'

function fixElementTabInitBug () {
  document.querySelector('.el-tabs__active-bar').style.width = '80px'
}

export default {
  name: 'znw-message',
  components: {
    list
  },
  props: {
    option: {
      type: Object,
      default: () => ({}),
      required: false,
      validator (opt) {
        return ['token', 'userId', 'sysCode'].every((key) => opt.hasOwnProperty(key))
      }
    }
  },
  data: () => ({
    activeTab: 'informs',
    newMsgNum: 12,

    informsNum: 0,
    remindsNum: 0,
    pendingsNum: 0,

    socket: null,

    msgTable: {
      informs: [
        {
          avatar: 'https://emallws.oss-cn-shenzhen.aliyuncs.com/cms/2966dafcad624210095a41e58ee734b0.jpg',
          shorthand: '三顿饭嘎多噶时光发噶时光阿瑟费噶多少分阿大使馆',
          time: '1年前'
        },
        {
          avatar: 'https://emallws.oss-cn-shenzhen.aliyuncs.com/cms/2966dafcad624210095a41e58ee734b0.jpg',
          shorthand: '光阿瑟费噶多少分阿大使馆',
          time: '2年前'
        },
        {
          avatar: 'https://emallws.oss-cn-shenzhen.aliyuncs.com/cms/2966dafcad624210095a41e58ee734b0.jpg',
          shorthand: '三顿饭嘎多噶时光发噶时光阿瑟费噶多少分阿大使馆',
          time: '1年前'
        },
        {
          avatar: 'https://emallws.oss-cn-shenzhen.aliyuncs.com/cms/2966dafcad624210095a41e58ee734b0.jpg',
          shorthand: '三顿饭嘎多噶时光发噶时光阿瑟费噶多少分阿大使馆',
          time: '1年前'
        },
        {
          avatar: 'https://emallws.oss-cn-shenzhen.aliyuncs.com/cms/2966dafcad624210095a41e58ee734b0.jpg',
          shorthand: '三顿饭嘎多噶时光发噶时光阿瑟费噶多少分阿大使馆',
          time: '1年前'
        },
        {
          avatar: 'https://emallws.oss-cn-shenzhen.aliyuncs.com/cms/2966dafcad624210095a41e58ee734b0.jpg',
          shorthand: '三顿饭嘎多噶时光发噶时光阿瑟费噶多少分阿大使馆',
          time: '1年前'
        },
        {
          avatar: 'https://emallws.oss-cn-shenzhen.aliyuncs.com/cms/2966dafcad624210095a41e58ee734b0.jpg',
          shorthand: '三顿饭嘎多噶时光发噶时光阿瑟费噶多少分阿大使馆',
          time: '1年前'
        }
      ],
      reminds: [
        {
          avatar: 'https://emallws.oss-cn-shenzhen.aliyuncs.com/cms/2966dafcad624210095a41e58ee734b0.jpg',
          shorthand: '三顿饭嘎多噶时光发噶时光阿瑟费噶多少分阿大使馆',
          time: '1年前'
        },
      ],
      pendings: [
        {
          avatar: 'https://emallws.oss-cn-shenzhen.aliyuncs.com/cms/2966dafcad624210095a41e58ee734b0.jpg',
          shorthand: '三顿饭嘎多噶时光发噶时光阿瑟费噶多少分阿大使馆',
          time: '1年前'
        },
      ]
    }
  }),
  mounted () {
    fixElementTabInitBug()

    this.getPermission()

    // this.initWebSocket()
  },
  methods: {
    getPermission () {
      Notification.requestPermission()
        .then((result) => {
          console.log(result)
        })
    },
    showNotification () {
      const num = Math.random()
      const notification = new Notification('你有新的消息', {
        body: '新消息xxxxxxxxxxxxxx' + num,
        silent: true,
        tag: num,
        renotify: false,
        // icon: '',
      })
      console.log(notification.renotify)
      console.log(notification.tag)
    },
    itemClick (item) {
      this.$emit('itemClick', item)
    },
    /**
     * 初始化webSocket链接
     * 1. 建立连接
     * 2. 订阅事件
    */
    initWebSocket () {
      this.socket = new Socket('ws://192.168.7.20:12000/msg', {
        userId: '1234',
        token: 'token-demo',
        sysCode: '001'
      })
      /**
       * 登陆成功后，后台推送历史未读的消息
       * 每种各10条
      */
      this.socket.on('Auth', (data) => {
        console.log('Auth回调', data)
        this.msgTable = {
          informs: data.informs,
          pendings: data.pendings,
          reminds: data.reminds,
        }
      })
      this.socket.on('Push', (data) => {
        console.log(data)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.z-msg-wrapper {
  line-height: 30px;
}
.z-msg__icon {
  font-size: 20px;
}

.z-msg__menu {
  width: 300px;
}
</style>

<style>
/* 修改element组件样式 */
.z-msg__menu.el-dropdown-menu {
  padding: 0;
}
.z-msg__menu .el-tabs__nav {
  width: 100%;
}
.z-msg__menu .el-tabs__header {
  margin: 0;
}
.z-msg__menu .el-tabs__item {
  padding: 0;
  width: 33.3%;

  text-align: center;
}
</style>
